import { createContext, useContext, useState } from 'react';

export const TablePreferenceScope = createContext('guest');
export type CollectionView = 'grid' | 'list' | 'table';
export function useCollectionView(caption: string, fallback: CollectionView = 'list', legacyKey = `collection-view:${caption}`) {
  const scope = useContext(TablePreferenceScope);
  const key = scope === 'guest' ? legacyKey : `collection-view:${scope}:${typeof window === 'undefined' ? '' : window.location.pathname}:${caption}`;
  const read = (): CollectionView => { try { const value = localStorage.getItem(key); return value === 'grid' || value === 'list' || value === 'table' ? value : fallback; } catch { return fallback; } };
  const [stored, setStored] = useState(() => ({ key, value: read() }));
  const value = stored.key === key ? stored.value : read();
  const setValue = (view: CollectionView) => { setStored({ key, value: view }); try { localStorage.setItem(key, view); } catch { /* Preferences are optional. */ } };
  return [value, setValue] as const;
}
